import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import { __decorate } from "tslib";
import { Component, createRef } from 'intact-vue';
import template from './index.vdt';
import { _$ } from '../../i18n';
import { bind } from '../utils';
import { useConfigContext } from '../config';
var typeDefs = {
  editing: Boolean,
  value: [String, Number],
  required: Boolean,
  validate: [Function, String, RegExp],
  disabled: Boolean,
  tip: [String, Number],
  trim: Boolean,
  invalid: Boolean
};
var defaults = function defaults() {
  return {
    required: true,
    tip: _$('编辑'),
    trim: true
  };
};
var events = {
  error: true,
  change: true
};
export var Editable = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Editable, _Component);
  function Editable() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.inputRef = createRef();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Editable.prototype;
  _proto.edit = function edit() {
    this.set('editing', true);
    /**
     * Intact will update in nextTick, but Vue will call
     * call updated method in nextTick of this nextTick
     * so we should do it after two nextTicks
     * https://github.com/ksc-fe/kpc/issues/847
     *
     * use binding this.select to Input $mounted event instead
     */
    // nextTick(() => {
    // nextTick(() => {
    // this.inputRef.value!.select();
    // });
    // });
  };
  _proto.select = function select() {
    this.inputRef.value.select();
  };
  _proto.onBlur = function onBlur(e) {
    this.setValue(e.target.value);
  };
  _proto.onKeydown = function onKeydown(e) {
    switch (e.keyCode) {
      case 27:
        // esc 
        this.set('editing', false);
        break;
      case 13:
        // enter
        this.onBlur(e);
        break;
    }
  };
  _proto.setValue = function setValue(value) {
    var _this$get = this.get(),
      validate = _this$get.validate,
      required = _this$get.required,
      trim = _trimInstanceProperty(_this$get),
      oldValue = _this$get.value;
    if (trim) value = _trimInstanceProperty(value).call(value);
    var valid = true;
    if (required && !value) {
      valid = false;
    } else if (validate && value) {
      if (typeof validate === 'function') {
        valid = validate.call(this, value);
      } else if (validate instanceof RegExp) {
        valid = validate.test(value);
      } else if (typeof validate === 'string') {
        valid = new RegExp(validate).test(value);
      }
    }
    if (!valid) {
      // do not change the value if invalid, #51
      // this.set('value', value, {silent: true});
      this.set('invalid', true);
      return this.trigger('error', value);
    }
    this.set({
      invalid: false,
      editing: false,
      value: value
    });
    if (oldValue !== value) {
      this.trigger('change', value, oldValue);
    }
  };
  return Editable;
}(Component);
Editable.template = template;
Editable.typeDefs = typeDefs;
Editable.defaults = defaults;
Editable.events = events;
__decorate([bind], Editable.prototype, "edit", null);
__decorate([bind], Editable.prototype, "select", null);
__decorate([bind], Editable.prototype, "onBlur", null);
__decorate([bind], Editable.prototype, "onKeydown", null);
__decorate([bind], Editable.prototype, "setValue", null);